export const modal = {
    DELETE_CONFIRM_MODAL : {
        fr : 'Confirmer la suppression ?'
    }
}